export default __webpack_public_path__ + "static/media/instagram.06100335.svg";